import { useEffect, useState } from "react"
import ReactSelect from "react-select"

export default function Select(props) {
    let height = props.height ? props.height : '44px'

    if (props.isMulti) {
        height = (Math.floor((props?.value?.length ?? 1) / 5) * 16) + 44
        height = height + "px"
    }

    if (props.forceHeightAuto) {
        height = "auto"
    }

    const [value, setValue] = useState();

    useEffect(() => {
        if (!props.resolveValueFromOptions) {
            setValue(props.value)

            return
        }

        const option = props.options.find(option => option.value === props.value)
        setValue(option ?? null)
    }, [props.value, props.options]);

    const styles = {
        option: (provided, state) => {
            let backgroundColor = state.isSelected ? '#4e9bed' : '#fff'
            if (state.isDisabled) backgroundColor = '#ededed'

            return {
                ...provided,
                backgroundColor,
                color: state.isSelected ? '#fff' : '#333',
                fontSize: '12px',
                textAlign: 'left',
                cursor: state.isDisabled ? 'not-allowed' : 'pointer',
                '&:hover': { backgroundColor: state.isDisabled ? '#ededed' : '#ccdfff' }
            }
        },
        noOptionsMessage: (provided) => ({
            ...provided,
            fontSize: '12px',
            padding: '8px 14px',
            color: '#888888'
        }),
        menu: (provided) => ({
            ...provided,
            width: '100%',
            border: '1px solid #d4d4d4',
            marginTop: '3px',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.3)',
            borderRadius: '8px',
            backgroundColor: '#fff',
            zIndex: 999999
        }),
        placeholder: (provided) => ({
            ...provided,
            color: '#111',
            opacity: 0.7
        }),
        singleValue: (provided) => ({
            ...provided,
            color: '#111'
        }),
        control: (provided, state) => ({
            ...provided,
            height,
            minHeight: '20px',
            borderRadius: '10px',
            padding: 0,
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
            overflow: 'hidden',
            backgroundColor: props.disabled ? '#efefef4d' : '#fff',

            border: props.hasError
                ? '1px solid #e74c3c'
                : state.isFocused
                    ? '1px solid var(--fonte_titulo_abas)'
                    : '1px solid #dfdfdf',

            boxShadow: props.hasError
                ? '0 0 0 2px rgba(231, 76, 60, 0.4)'
                : 'none',

            outline: 'none',

            '&:hover': {
                border: props.hasError
                    ? '1px solid #e74c3c'
                    : '1px solid #bebebe',
                cursor: 'pointer'
            }
        }),
        valueContainer: (provided) => ({
            ...provided,
            flexWrap: props.ellipsisMulti ? 'nowrap' : 'wrap',
            overflowX: props.ellipsisMulti ? 'auto' : 'visible',
            overflowY: 'hidden',
            whiteSpace: props.ellipsisMulti ? 'nowrap' : 'normal',
            scrollbarWidth: 'thin',
        }),
        multiValue: (provided) => ({
            ...provided,
            fontSize: '12px',
            borderRadius: '6px',
            flex: props.ellipsisMulti ? '0 0 auto' : 'initial',
        }),
        input: (provided) => ({
            ...provided,
            margin: 0,
            padding: 0,
            border: 0,
            outline: 0,
            boxShadow: 'none',
            backgroundColor: 'transparent',
        }),
    }

    return (
        <ReactSelect
            classNamePrefix="rs"
            value={value}
            onChange={props.onChange}
            options={props.options}
            defaultValue={props.defaultValue}
            isDisabled={props.disabled ?? false}
            closeMenuOnSelect={props.closeMenuOnSelect ?? true}
            style={props.style}
            isMulti={props.isMulti ?? false}
            isClearable={props.isClearable}
            components={props.components}
            placeholder={props.placeholder ?? "Selecione"}
            noOptionsMessage={() => props.noOptionsMessage ?? "Sem Opções"}
            menuIsOpen={props.menuIsOpen}
            styles={styles}
        />
    )
}